import React from 'react';

function Thankyou({ onBackToHome }) {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        
        {/* Brand Logo & Header */}
        <div style={styles.logoSection}>
          <h1 style={styles.brandTitle}>HOTELZIO</h1>
          <p style={styles.brandSubtitle}>Luxury & Comfort Redefined</p>
        </div>

        <div style={styles.divider} />

        {/* Animated Checkmark Icon */}
        <div style={styles.iconCircle}>
          <svg style={styles.checkIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>

        {/* Main Content */}
        <h2 style={styles.heading}>Your Booking Was Successful!</h2>
        <p style={styles.subtext}>
          Thank you for choosing Hotelzio. Your reservation has been confirmed, and we look forward to providing you with an exceptional stay.
        </p>

        {/* Action Button */}
        <button 
          style={styles.homeBtn} 
          onClick={onBackToHome || (() => window.location.href = '/')}
        >
          Back to Home
        </button>

      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f0f4f8 0%, #e2e8f0 100%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    fontFamily: "'Segoe UI', Roboto, -apple-system, sans-serif",
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    boxShadow: '0 12px 32px rgba(0, 0, 0, 0.08)',
    maxWidth: '480px',
    width: '100%',
    padding: '40px 32px',
    textAlign: 'center',
  },
  logoSection: {
    marginBottom: '20px',
  },
  logoBadge: {
    width: '64px',
    height: '64px',
    borderRadius: '50%',
    backgroundColor: '#1976d2',
    color: '#ffffff',
    fontSize: '24px',
    fontWeight: '700',
    letterSpacing: '1px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 12px auto',
    boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
  },
  brandTitle: {
    fontSize: '26px',
    color: '#1e293b',
    margin: '0',
    fontWeight: '700',
    letterSpacing: '-0.5px',
  },
  brandSubtitle: {
    fontSize: '13px',
    color: '#64748b',
    margin: '4px 0 0 0',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  divider: {
    height: '1px',
    backgroundColor: '#e2e8f0',
    margin: '24px 0',
  },
  iconCircle: {
    width: '72px',
    height: '72px',
    borderRadius: '50%',
    backgroundColor: '#dcfce7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 20px auto',
  },
  checkIcon: {
    width: '36px',
    height: '36px',
    color: '#16a34a',
  },
  heading: {
    fontSize: '22px',
    color: '#0f172a',
    margin: '0 0 12px 0',
    fontWeight: '700',
  },
  subtext: {
    fontSize: '15px',
    color: '#475569',
    lineHeight: '1.6',
    margin: '0 0 32px 0',
  },
  homeBtn: {
    backgroundColor: '#1976d2',
    color: '#ffffff',
    border: 'none',
    padding: '12px 28px',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    width: '100%',
    boxShadow: '0 4px 12px rgba(25, 118, 210, 0.25)',
    transition: 'background-color 0.2s ease, transform 0.1s ease',
  },
};

export default Thankyou;